import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

// Odikai playbook types the admin has hidden (is_public set to false on odikai_<type>).
// Usually none, so this query returns nothing; on failure every playbook stays visible.
export async function fetchHiddenOdikaiTypes() {
  try {
    const snapshot = await getDocs(query(
      collection(db, 'playbooks'),
      where('is_prebuilt', '==', true),
      where('is_public', '==', false)
    ));
    const hidden = new Set();
    snapshot.forEach((doc) => {
      const type = doc.data().type || doc.id.replace(/^odikai_/, '');
      if (type) hidden.add(type);
    });
    return hidden;
  } catch (error) {
    return new Set();
  }
}
